import bus from "@/bus";
const pixelDb = require(`./${_BBVA_CAMP}/pixelDb.js`).default;
import pxRunner from "./pxRunner";
import { ON_ROUTE } from "../config/constants/mutation-types";

const pixels = {
  initProvider(key, provider, Vue) {
    pxRunner.enableProvider(provider, () => {
      Vue.$log.info(
        `se habilitó el provider: ${key}. Ejecutando la cola de pxs probablemente llamados`
      );

      if (provider.queue && provider.queue.length > 0) {
        for (const item of provider.queue) {
          Vue.$log.info(`Procesando cola de provider: ${key}`);
          item();
        }
      }
    });
  },
  install(Vue) {
    for (let key in pixelDb.providers) {
      pixels.initProvider(key, pixelDb.providers[key], Vue);
    }

    bus.$on("mutation", mutationObj => {
      let mutation = mutationObj.mutation;
      // Hay un trigger para este tipo de mutation ?
      let trigger = pixelDb.triggers[mutation.type];
      if (trigger) {
        // El trigger 'ON_ROUTE' lleva el nombre del route, dentro del payload
        let phases = null;
        if (mutation.type === ON_ROUTE) {
          phases = trigger[mutation.payload.name];
        } else {
          phases = trigger;
        }
        // Si tiene phases avanzo
        if (phases) {
          for (const phase of phases) {
            pxRunner.run(phase, mutationObj);
          }
        }
      }
    });
  }
};

export default pixels;
